import axios from "@/plugins/axios";

let url = (data) => "/api/v1/expo/programs/${_program}/matchings".interpolate(data);

export const matchings = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};

export default matchings;
